export default __webpack_public_path__ + "ef020d610a34502f30d20afacecc92c7.png";